<div class="refund-payment-dialog">
  <div class="ws-popup-header">
    <div>
      {{ "refund_dialog.title" | translate }}
    </div>
  </div>

  <div class="ws-popup-content">
    <div class="ws-popup-body">
      
      <!-- Transaction Summary -->
      <div class="transaction-summary">
        <h3 class="summary-title">{{ "refund_dialog.transaction_summary" | translate }}</h3>
        
        <div class="summary-row">
          <span class="summary-label">{{ "refund_dialog.customer_name" | translate }}</span>
          <span class="summary-value">{{ data.customerName }}</span>
        </div>
        
        <div class="summary-row">
          <span class="summary-label">{{ "refund_dialog.paid_amount" | translate }}</span>
          <span class="summary-value amount">{{ refundAmount }}</span>
        </div>
        
        <div class="summary-row">
          <span class="summary-label">{{ "refund_dialog.payment_date" | translate }}</span>
          <span class="summary-value">{{ data.paymentDate | date:'dd/MM/yyyy' }}</span>
        </div>
        
        <div class="summary-row">
          <span class="summary-label">{{ "refund_dialog.payment_method" | translate }}</span>
          <span class="summary-value">WineSuite Payments</span>
        </div>
      </div>

      <!-- Warning Banner -->
      <div class="alert-banner">
        <div class="alert-content">
          <span class="danger-icon">⚠️</span>
          <div class="alert-text">
            <div class="alert-description">
              {{ "refund_dialog.warning" | translate }}
            </div>
          </div>
        </div>
      </div>

      <!-- Loading state -->
      <div class="processing-overlay" *ngIf="isProcessing">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="processing-text">{{ processingMessage | translate }}</p>
      </div>
    </div>

    <div class="ws-popup-footer">
      <ws-button 
        (click)="onCancel()"
        [disabled]="isProcessing"
        [callToActionType]="'danger'">
        {{ "Cancel" | translate }}
      </ws-button>
      <ws-button 
        color="warn"
        (click)="onConfirm()"
        [disabled]="isProcessing"
        [callToActionType]="'primary'">
        {{ "Confirm" | translate }}
      </ws-button>
    </div>
  </div>
</div>
